import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useTrailingUrl = () => {
     const location = useLocation();
     const navigate = useNavigate();
     const fullPath = `${location.pathname}${location.search}${location.hash}`;

     useEffect(() => {
          if (!fullPath.endsWith('/')) {
               navigate(`${fullPath}/`, { replace: true });
          }
     }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useTrailingUrl;
